import { render, staticRenderFns } from "./FacultyFilter.vue?vue&type=template&id=476884d0&"
import script from "./FacultyFilter.vue?vue&type=script&lang=js&"
export * from "./FacultyFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports